/** Returns true when the event target is inside a Base UI combobox popup (portalled). */
export function isComboboxPopupElement(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest(
      '[data-slot="combobox-content"], [data-slot="combobox-item"], [data-slot="combobox-list"]'
    ) != null
  )
}

/** Use on Radix `DialogContent` to avoid treating combobox popup clicks as outside dismiss. */
export function preventDialogDismissForCombobox(event: {
  preventDefault: () => void
  target: EventTarget | null
}): void {
  if (isComboboxPopupElement(event.target)) {
    event.preventDefault()
  }
}
